module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li class="'+
((__t=( ifelse(item.hasRecipient, 'has-child', 'no-child') ))==null?'':_.escape(__t))+
'">\n    <h4>'+
((__t=(item.name))==null?'':_.escape(__t))+
'</h4>\n    ';
 if (item.hasRecipient) { 
__p+='\n        '+
((__t=( icon('next-small') ))==null?'':__t)+
'\n    ';
 } else { 
__p+='\n        '+
((__t=( icon('deposit') ))==null?'':__t)+
'\n    ';
 } 
__p+='\n</li>';
}
return __p;
};